export interface AppBranding {
  browserTitle: string;
  headerTitle: string;
  login: {
    logoAlt: string;
    title: string;
    subtitle: string;
    emailPlaceholder: string;
    passwordPlaceholder: string;
    forgotPasswordLink: string;
    submitButton: string;
    footerLogoAlt: string;
  };
  forgotPassword: {
    emailStepTitle: string;
    emailStepDescription: string;
    emailInputPlaceholder: string;
    skipToCodeLink: string;
    emailCommunicationText: string;
    codeStepTitle: string;
    codeStepDescriptionPrefix: string;
    newPasswordTitle: string;
    newPasswordPlaceholder: string;
    confirmPasswordPlaceholder: string;
    passwordRequirementsTitle: string;
    termsIntro: string;
    termsOfUseLabel: string;
    privacyIntro: string;
    privacyLabel: string;
    confirmButton: string;
    continueButton: string;
  };
  reports: {
    signature: string;
    primaryColor: string;
    chipTextColor: string;
    chipBorderColor: string;
    mutedBackgroundColor: string;
    excelHeaderColor: string;
  };
}

type AppBrandingOverrides =
  Partial<Omit<AppBranding, 'login' | 'forgotPassword' | 'reports'>> & {
    login?: Partial<AppBranding['login']>;
    forgotPassword?: Partial<AppBranding['forgotPassword']>;
    reports?: Partial<AppBranding['reports']>;
  };

declare global {
  interface Window {
    APP_BRANDING?: AppBrandingOverrides;
  }
}

const defaultBranding: AppBranding = {
  browserTitle: 'Liga',
  headerTitle: 'Liga',
  login: {
    logoAlt: 'Logo da aplicação',
    title: 'Bem-vindo',
    subtitle: 'Faça login para continuar',
    emailPlaceholder: 'E-mail',
    passwordPlaceholder: 'Senha',
    forgotPasswordLink: 'Esqueceu a senha?',
    submitButton: 'Entrar',
    footerLogoAlt: 'Liga',
  },
  forgotPassword: {
    emailStepTitle: 'Redefinição de senha',
    emailStepDescription: 'Informe o e-mail cadastrado na sua conta e siga as instruções que serão enviadas.',
    emailInputPlaceholder: 'E-mail',
    skipToCodeLink: 'Já tenho o código',
    emailCommunicationText: 'A aplicação irá enviar comunicações e histórico para este e-mail.',
    codeStepTitle: 'Código de verificação',
    codeStepDescriptionPrefix: 'Digite o código de 6 dígitos enviado para',
    newPasswordTitle: 'Crie uma nova senha',
    newPasswordPlaceholder: 'Nova senha',
    confirmPasswordPlaceholder: 'Confirme a senha',
    passwordRequirementsTitle: 'Sua senha deve conter:',
    termsIntro: 'Ao confirmar, você concorda com os',
    termsOfUseLabel: 'Termos de Uso',
    privacyIntro: 'e está ciente da',
    privacyLabel: 'Declaração de Privacidade.',
    confirmButton: 'Confirmar',
    continueButton: 'Continuar',
  },
  reports: {
    signature: 'Liga',
    primaryColor: '#FD8F31',
    chipTextColor: '#64625D',
    chipBorderColor: '#64625D',
    mutedBackgroundColor: '#F7F7F7',
    excelHeaderColor: '#FD8F31',
  },
};

const externalBranding = (globalThis as typeof globalThis & { APP_BRANDING?: AppBrandingOverrides }).APP_BRANDING;

export const appBranding: AppBranding = {
  ...defaultBranding,
  ...externalBranding,
  login: {
    ...defaultBranding.login,
    ...externalBranding?.login,
  },
  forgotPassword: {
    ...defaultBranding.forgotPassword,
    ...externalBranding?.forgotPassword,
  },
  reports: {
    ...defaultBranding.reports,
    ...externalBranding?.reports,
  },
};
